import { useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { Stack } from "@mui/material";
import clsx from "clsx";

import type { UserCourseLesson } from "api/schemas/UserCourse";

import { DropZoneContainer, DropZoneIndicator } from "../shared";
import { ActivityItem } from "../TreatmentScheduleExercises/ActivityItem";

interface TreatmentScheduleLessonsProps {
  lessons: UserCourseLesson[];
  onPreview: (id: number, part: number) => void;
  onRemove: (lessonID: number) => void;
}

export const TreatmentScheduleLessons: React.FC<TreatmentScheduleLessonsProps> = ({ lessons, onPreview, onRemove }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: "lessons",
    data: {
      droppableType: "lessons",
    },
  });

  return (
    <DropZoneContainer ref={setNodeRef} className={clsx({ "is-over": isOver })}>
      <SortableContext items={lessons.map(lesson => lesson.id)} strategy={verticalListSortingStrategy}>
        <Stack spacing={2}>
          {lessons.length > 0 && (
            <Stack spacing={2}>
              {lessons.map(lesson => (
                <ActivityItem
                  key={lesson.id}
                  activity={lesson}
                  onPreview={() => onPreview(lesson.id, 1)}
                  onRemove={() => onRemove(lesson.id)}
                />
              ))}
            </Stack>
          )}

          <DropZoneIndicator activityType="lessons" />
        </Stack>
      </SortableContext>
    </DropZoneContainer>
  );
};
